import React, { FC, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import classnames from "classnames";
import useStyles from "./Style";
import { useNavigate } from "react-router-dom";
import { useLazyQuery } from "@apollo/client";
import { TokenExpiration } from "../../../graphql/onboarding/auth/types/TokenExpiration";
import { TOKEN_EXPIRATION } from "../../../graphql/onboarding/auth/query";
import {
  clearLocalStorage,
  isAuthenticated,
} from "../../../services/LocalStorage";

interface MainLayoutProps {
  children: React.ReactNode;
  background?: string;
  title?: string;
  description?: string;
  isDoubleContent?: boolean;
  loading?: boolean;
}

const MainLayout: FC<MainLayoutProps> = ({
  children,
  title,
  description,
  background,
  isDoubleContent,
  loading,
}) => {
  const classes = useStyles();
  const navigate = useNavigate();

  // Check token if valid
  const [checkToken] = useLazyQuery<TokenExpiration>(TOKEN_EXPIRATION, {
    onCompleted: (data) => {
      if (data && !data.tokenExpiration) {
        tokenNotValid();
      }
    },
    onError: () => {
      tokenNotValid();
    },
  });
  useEffect(() => {
    isAuthenticated().then((auth) => {
      if (auth) {
        checkToken();
      } else {
        tokenNotValid();
      }
    });
  }, []);

  const tokenNotValid = () => {
    clearLocalStorage();
    return NotFoundRedirect();
  };

  const NotFoundRedirect = () => navigate("/");

  return (
    <Box className={classes.root}>
      <Box
        className={classnames(
          classes.left,
          isDoubleContent ? classes.leftWidthDouble : classes.leftWidthNormal,
        )}
      >
        {/* Background */}
        <Box className={classes.overlay}></Box>
        <img src={background} alt=" " className={classes.background} />
        <Box className={classes.contentLeft}>
          <Box className={classes.header}>
            <img
              className={classes.logo}
              src={"/assets/svg/logo.svg"}
              alt=" "
            />
            <Typography component="h1" className={classes.headTitle}>
              Sapheer
            </Typography>
          </Box>
          {title && (
            <Box className={classes.headerRow}>
              <Typography component="h1" className={classes.title}>
                {title}
              </Typography>
            </Box>
          )}
          {description && (
            <Typography component="h6" className={classes.description}>
              {description}
            </Typography>
          )}
        </Box>
      </Box>
      <Box
        className={classnames(
          classes.right,
          isDoubleContent ? classes.rightWidthDouble : classes.rightWidthNormal,
        )}
      >
        <Box className={classes.contentRight}>
          {loading ? (
            <Box
              className={
                isDoubleContent ? classes.loadingDouble : classes.loadingNormal
              }
            >
              <CircularProgress />
            </Box>
          ) : (
            <Card
              className={classes.card}
              style={{ maxWidth: isDoubleContent ? "100%" : "38rem" }}
            >
              <CardContent className={classes.cardContent}>
                {children}
              </CardContent>
            </Card>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default MainLayout;
